import styled from 'styled-components'

const DescriptiveSecondaryStyle = styled.div`
	--subtitleMarginTopAndBottom: var(--sp7x) 0 var(--sp9x) 0;
	--subtitleMaxWidth: var(--sp200x);
	--descriptionWrapMarginTop: var(--sp9x);
	--descriptionMaxWidth: var(--sp86x);
	--descriptionSecondSectionFirstChild: var(--sp11x);
	--listPaddingLeft: var(--sp3x);
	--listItemMarginTopBottom: var(--sp1x) 0;

	.subtitle {
		margin: var(--subtitleMarginTopAndBottom);
		max-width: var(--subtitleMaxWidth);
	}

	.descriptions-wrap {
		margin-top: var(--descriptionWrapMarginTop);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeXLMin}) {
		--subtitleMarginTopAndBottom: var(--sp5x) 0 var(--sp7x) 0;
		--subtitleMaxWidth: var(--sp149x);
		--descriptionWrapMarginTop: var(--sp7x);
		--descriptionMaxWidth: var(--sp64x);
		--descriptionSecondSectionFirstChild: var(--sp10x);
		--descriptionWrapMarginTop: var(--sp7x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeLMin}) {
		--subtitleMarginTopAndBottom: var(--sp4x) 0 var(--sp6x) 0;
		--subtitleMaxWidth: var(--sp117x);
		--descriptionWrapMarginTop: var(--sp6x);
		--descriptionMaxWidth: var(--sp50x);
		--descriptionSecondSectionFirstChild: var(--sp9x);
		--descriptionWrapMarginTop: var(--sp6x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeMMin}) {
		--subtitleMarginTopAndBottom: var(--sp4x) 0 var(--sp6x) 0;
		--subtitleMaxWidth: var(--sp112x);
		--descriptionWrapMarginTop: var(--sp6x);
		--descriptionMaxWidth: var(--sp61x);
		--descriptionSecondSectionFirstChild: var(--sp9x);
		--descriptionWrapMarginTop: var(--sp6x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeSMin}) {
		--subtitleMarginTopAndBottom: var(--sp4x) 0 var(--sp5x) 0;
		--subtitleMaxWidth: var(--sp101x);
		--descriptionWrapMarginTop: var(--sp5x);
		--descriptionMaxWidth: var(--sp62x);
		--descriptionSecondSectionFirstChild: var(--sp8x);
		--descriptionWrapMarginTop: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeXSMin}) {
		--subtitleMarginTopAndBottom: var(--sp3x) 0 var(--sp4x) 0;
		--subtitleMaxWidth: var(--sp98x);
		--descriptionWrapMarginTop: var(--sp4x);
		--descriptionMaxWidth: var(--sp52x);
		--descriptionSecondSectionFirstChild: var(--sp8x);
		--descriptionWrapMarginTop: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.TabletSizeMin}) {
		--subtitleMarginTopAndBottom: var(--sp3x) 0 var(--sp5x) 0;
		--subtitleMaxWidth: 100%;
		--descriptionWrapMarginTop: var(--sp5x);
		--descriptionMaxWidth: var(--sp70x);
		--descriptionSecondSectionFirstChild: 0;
		--descriptionWrapMarginTop: var(--sp5x);

		.descriptions-wrap {
			flex-direction: column;
			.description {
				&:first-child {
					margin-bottom: var(--sp3x);
				}
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--subtitleMarginTopAndBottom: var(--sp3x) 0 var(--sp5x) 0;
		--subtitleMaxWidth: 100%;
		--descriptionWrapMarginTop: var(--sp5x);
		--descriptionMaxWidth: 100%;
		--descriptionSecondSectionFirstChild: 0;
		--descriptionWrapMarginTop: var(--sp5x);

		.descriptions-wrap {
			flex-direction: column;
			.description {
				&:first-child {
					margin-bottom: var(--sp3x);
				}
			}
		}
	}
`

export default DescriptiveSecondaryStyle
